export default {
  image: 'ford.png',
  baseRoute: 'https://ford.phoenixmi.com/Ford/login.aspx',
  description:
    'Ford/Lincoln - Historical Tier 1/1.5/2 Advertising Dashboard (Prior to Jan 2019)'
}


// WEBPACK FOOTER //
// ./src/app/configuration/FordLegacy/config/main.js